
let lastKeyword = "";
let lastHTML = "";


function gameOfInput(input){
  const el = input.closest('.header-search-inline');
  return {
    title: el?.dataset.cardTitle || '',
    key: el?.dataset.gameKey || ''
  };
}


function fixSuggestMoreLink(box, input){

  const link = box.querySelector('[data-suggest-more]');
  if(!link) return;

  const game = gameOfInput(input);
  let href = link.getAttribute('href') || '/search';

  if(game.title){
    href += `&game=${encodeURIComponent(game.key)}&filter.p.m.custom.card_title=${encodeURIComponent(game.title)}`;
  }

  link.setAttribute('href', href);
}


function getSuggestUrl(input, keyword){

  const game = gameOfInput(input);

  let url =
    `/search?q=${encodeURIComponent(keyword)}&view=suggest&type=product`;

  if(game.title){
    url +=
      `&filter.p.m.custom.card_title=${encodeURIComponent(game.title)},common&game=${encodeURIComponent(game.key)}`;
  }

  return url;
}


document.addEventListener("input", function(e){

  if(!e.target.matches('.search__input')) return;


  let box = document.getElementById("search-suggest");


  if(!box){
    box = document.createElement("div");
    box.id = "search-suggest";
    e.target.closest(".field").appendChild(box);
  }


  const keyword = e.target.value.trim();
  lastKeyword = keyword;


  if(keyword.length < 2){
    box.innerHTML = "";
    return;
  }


  clearTimeout(window.searchTimer);


  window.searchTimer = setTimeout(()=>{


    fetch(getSuggestUrl(e.target, keyword))

    .then(r=>r.text())

    .then(html=>{


      const parser =
        new DOMParser();

      const doc =
        parser.parseFromString(html,"text/html");


      const results =
        doc.querySelector("#search-suggest-results");


      if(results){

        lastHTML =
          results.innerHTML;

        box.innerHTML =
          lastHTML;

        fixSuggestMoreLink(box, e.target);

      }


    });


  },200);


});


document.addEventListener("click", function(e){

const box =
document.getElementById("search-suggest");

const search =
document.querySelector(".search__input");


if(!box || !search) return;


if(!search.contains(e.target)
&& !box.contains(e.target)){

box.innerHTML="";

}

});


document.addEventListener("focusin", function(e){

if(!e.target.matches('.search__input')) return;


const box =
document.getElementById("search-suggest");


if(!box) return;


const keyword =
e.target.value.trim();


if(!keyword) return;


if(lastHTML){

box.innerHTML =
lastHTML;

fixSuggestMoreLink(box, e.target);

return;

}



fetch(getSuggestUrl(e.target, keyword))


.then(r=>r.text())


.then(html=>{


const parser =
new DOMParser();


const doc =
parser.parseFromString(html,"text/html");


const results =
doc.querySelector("#search-suggest-results");


if(results){

lastHTML =
results.innerHTML;

box.innerHTML =
lastHTML;

fixSuggestMoreLink(box, e.target);

}


});


});
